import Profile from "../../../../assets/images/profile_placeholder.png";
import { Link } from "react-router-dom";
import { GlobalContext } from "../../../../context/Provider";
import axios from "axios";
import henceforthApi from "../../../../utils/henceforthApi";
import { useContext } from "react";
import React from "react";
import { ROLES_STAFF_MEMBERS } from "../../../../constants/actionTypes";

const ProfileDropdown = ({ roles }) => {
  const { authState, authDispatch } = useContext(GlobalContext);
  henceforthApi.setToken(authState.access_token);

  return (
    <div class="dropdown profile-element icon-d-none">
      <div>
        <img
          class="profile-img"
          src={
            authState.image
              ? `${henceforthApi.API_ROOT_IMAGEUPLOAD}${authState.image}`
              : Profile
          }
          alt=""
        />
      </div>
      <button
        class="dropdown-toggle btn-icon"
        type="button"
        id="dropdownMenu2"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <span class="text-white">
          <span class="text-dark text-xs block">
            {authState.name?.charAt(0).toUpperCase() + authState.name?.slice(1)}
            <b class="caret"></b>
          </span>
        </span>
      </button>
      <ul
        class="dropdown-menu animated fadeInRight m-t-xs"
        aria-labelledby="dropdownMenu2"
      >
        <li>
          <Link class="dropdown-item" to="./profile">
            Profile
          </Link>
        </li>
        {/* <li>
          {roles.includes(ROLES_STAFF_MEMBERS) || authState.super_admin ? (
            <Link class="dropdown-item" to="/staffs/1/all">
              Staff Management
            </Link>
          ) : (
            ""
          )}
        </li> */}
      </ul>
    </div>
  );
};

export default ProfileDropdown;
